import React, { useEffect, useState } from "react";

import "../members-access/mspMembersAccess.scss"
import { useAuth } from "../../context/Auth";
import { getAPIData, postJsonData, postRequest } from "../../../Utils/commonApi";
import { CallToast } from "../../PriceCalculator/modals/CustomToast";
import SlidingModal from "../../CustomModal/SlidingModal";
import OrderSummary from "../../Common/loader";
import AccessItem from "./AccessItem";
import { Button } from "react-bootstrap";
import { API_DOMENS } from "../../../constants/apis.constants";

const MspAccessLevelModal = ({ show, hideModal, parentID, accessLevelId, refreshData, refreshDataOnDelete, dontAllowEdit, setUsersInUseData }) => {
  const { authTokens } = useAuth();
  const [loading, setLoading] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [saving, setSaving] = useState(false);
  const [accessSettings, setAccessSettings] = useState([]);
  const [role, setRole] = useState({});

  useEffect(() => {
    if (show) {
      setLoading(true);
      getAccessSettings();
    }
  }, [show]);

  async function getAccessSettings() {
    await getAPIData("552", authTokens, {
      optionEnum1: accessLevelId ? accessLevelId : 0
    }, API_DOMENS.CC_API).then((response) => {
      if (response?.mr?.Success) {
        console.log(response);
        setRole(response.data?.role);
        setAccessSettings(response.data?.permissions?.filter((item) => item?.moduleName != "Technical Drilldown" && item?.moduleName != "Cyber Trend Data" && item?.moduleName != "Pro Services"
          && item?.moduleName != "MSP Attack Surface Insights" && item?.moduleName != "Logs" && item?.moduleGroup != 'Marketing'));
        setLoading(false);
      }
    });
  }

  function changeAccessDropdown(obj, name) {
    let newSettings = accessSettings.map(setting => {
      if (setting.moduleName === name) {
        setting.selected_AccessState = obj;
      }
      return setting;
    });
    setAccessSettings(newSettings);
  }

  async function deleteAccessLevel() {
    setDeleting(true);
    await postRequest(authTokens, "DeleteAccessRole", {
      objId_AccessRole: accessLevelId,
      accessKey: JSON.parse(localStorage.getItem("user_MessageObj")),
    }
    , API_DOMENS.CC_API)
      .then((response) => {
        setDeleting(false);
        if (response?.mr?.Success) {
          CallToast("Access role deleted successfully", false, false, "v2style");
          hideModal();
          if (refreshDataOnDelete) {
            refreshDataOnDelete();
          }
        } else {
          setUsersInUseData(response?.detail);
        }
      })
      .catch(() => {
        CallToast("Something went wrong", false, false, "v2style");
      });
  }

  async function sendRequest() {
    setSaving(true);
    let accessObject = { role: role, permissions: accessSettings };

    if (accessObject?.role?.RoleName && accessObject?.role?.RoleName.trim() !== "") {
      await postJsonData(authTokens, "UpsertAccessRole", accessObject, API_DOMENS.CC_API)
        .then((response) => {
          setSaving(false);
          if (response?.Success) {
            CallToast("Access role updated successfully", false, false, "v2style");
            hideModal();
            if (refreshData) {
              refreshData();
            }
          } else {
            CallToast(response.Message, false, false, "v2style");
          }
        })
        .catch(() => {
          CallToast("Something went wrong", false, false, "v2style");
        });
    }
    else {
      CallToast("Access role cannot be empty", false, false, "v2style");
      setSaving(false);

    }
  }

  return (
    <SlidingModal
      show={show}
      parentID={parentID}
      id="ounsqxw"
      onHide={hideModal}
      className="common-big-modal memberAccessModal"
    >
      <SlidingModal.Header className=" text-center d-flex p-3 border-bottom">
        <div className="w-100 mb-0 font-bold-14 title" style={{ fontWeight: "600" }}>
          {accessLevelId === 0 ? "Add Client Access Role" : role?.RoleName}
        </div>

        <span className="cursor-pointer" onClick={hideModal}>
          <img src="/images/attack-surface/cross-icon.svg" alt="" />
        </span>
      </SlidingModal.Header>
      <SlidingModal.Body className={`msp-service-add-edit-modal    ${true}`}>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center w-100" style={{ height: "85vh" }}>
            <OrderSummary />
          </div>
        ) : (
          <div className="m-24px">
            <InputItem
              isDisable={dontAllowEdit}
              placeholder={'Name: Type'}
              value={role?.RoleName}
              onChange={(value) => { setRole({ ...role, RoleName: value }) }}
            />
            <InputItem
              isDisable={dontAllowEdit}
              placeholder={'Description: Type'}
              value={role?.RoleDescription}
              onChange={(value) => { setRole({ ...role, RoleDescription: value }) }}
            />

            <div className="border-top mt-24px">
              <div className="f-12 f-darkgrey mt-16px" >Build access</div>
              {
                accessSettings.map((setting, index) => {
                  return (
                    <AccessItem
                      key={`${setting.moduleName} + ${index}`}
                      name={setting.moduleName}
                      description={setting.moduleDescription}
                      dontAllowEdit={dontAllowEdit}
                      options={setting.accessStates}
                      selectedOption={setting.selected_AccessState}
                      onSelectOption={(optionItem) => {
                        changeAccessDropdown(optionItem, setting.moduleName);
                      }}
                    />
                  );
                })
              }
            </div>
          </div>
        )}

      </SlidingModal.Body>
      <SlidingModal.Footer className="p-3 position-sticky w-100 border-top">
        <div className="d-flex align-items-center justify-content-between">
          {
            !dontAllowEdit ? <>
              <div>
                {accessLevelId > 0 && (
                  <div className="d-flex align-items-center f-500 f-grey pointer" onClick={() => { deleteAccessLevel(); }}>
                    <img alt="" className="mx-2" src="/images/actioncenter/delete.svg" />
                    {deleting ? "Deleting..." : "Delete"}
                  </div>
                )}
              </div>
            </> : <div className="w-100"></div>
          }

          <div className="d-flex justify-content-end">
            <Button className="hg-cancel-btn mr-2" onClick={hideModal}>
              Cancel
            </Button>
            {
              !dontAllowEdit &&
              <Button className="hg-blue-btn" onClick={() => { sendRequest() }}>
                {saving ? 'Saving..' : 'Save'}
              </Button>
            }
          </div>
        </div>
      </SlidingModal.Footer>
    </SlidingModal>
  );
};

export default MspAccessLevelModal;

export const InputItem = ({
  isDisable = false,
  placeholder = 'Type',
  value = '',
  onChange = (value) => { }
}) => (
  <div className="asset-name-wrapper d-flex align-items-center p-2 radius-4 my-2">
    <input
      disabled={isDisable}
      tabIndex={0}
      type="text"
      placeholder={placeholder}
      className="flex-grow-1 pl-3 pr-2"
      value={value}
      onChange={(e) => { onChange(e.target.value) }}
    />
  </div>
)
